import React from 'react';
import {Button} from 'antd';

export default function WidgetButton(props) {
  return <Button type="primary" style={{}} {...props} />;
}
